import i18n from "@microdoing/shared/i18n";
import React, { useState } from "react";
import { StatusBar, StyleSheet, View } from "react-native";
import IntroCarousel from "./IntroCarousel";
import {
  Box,
  MainButton,
  MainText,
  MySafeAreaView,
  PressableOpacity,
} from "app/components/common";
import theme from "app/Theme/Theme";
import normalize from "app/utils/normalize";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import { widthPercentageToDP } from "react-native-responsive-screen";
import { useNavigation } from "@react-navigation/native";
import WebWelcomeScreen from "./WebWelcomeScreen";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import LogoFullMicrodoing from "app/components/Icons/logo/LogoFullMicrodoing";

const styles = StyleSheet.create({
  topView: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
  gotAccountButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: isWebDesktop ? theme.spacing.s : theme.spacing.xxs,
    flexDirection: "column",
  },
  longLogo: {
    alignSelf: "center",
    width: "100%",
    height: normalize(25),
    marginTop: normalize(35),
  },
});

const WelcomeScreen = ({}) => {
  const navigation = useNavigation();
  const insets = useSafeAreaInsets();

  const navigationToSignUp = () => {
    navigation.navigate("Signup");
  };

  const navigationToAuth = () => {
    navigation.push("Login");
  };

  if (isWebDesktop) {
    return (
      <WebWelcomeScreen
        navigationToAuth={navigationToAuth}
        navigationToSignUp={navigationToSignUp}
      />
    );
  }

  return (
    <MySafeAreaView flex={1}>
      <Box
        flex={1}
        width="100%"
        backgroundColor="neutral.white"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        alignSelf="center"
        variant="screenView"
      >
        <Box
          style={styles.longLogo}
          justifyContent="center"
          alignItems="center"
        >
          <LogoFullMicrodoing height={normalize(25)} width={normalize(150)} />
        </Box>
        <StatusBar
          backgroundColor={theme.colors["neutral.white"]}
          barStyle="dark-content"
        />
        <View style={styles.topView}>
          <IntroCarousel />
        </View>
        <Box
          width={widthPercentageToDP("100%") - 64}
          alignSelf="center"
          alignItems="center"
          justifyContent="flex-end"
          flexDirection="column"
          marginBottom="m"
        >
          <MainButton
            testID="signup-button"
            onPress={navigationToSignUp}
            text={i18n.t("got-magic-code")}
          />
          <PressableOpacity
            testID="login"
            style={styles.gotAccountButton}
            onPress={navigationToAuth}
          >
            <Box
              flexDirection="row"
              justifyContent="flex-end"
              alignItems="center"
            >
              <MainText
                variant="l4-medium"
                color="neutral.800"
                marginRight="xxs"
              >
                {i18n.t("got-account")}
              </MainText>
              <MainText variant="l4-semibold" color="brand.500">
                {i18n.t("log-me")}
              </MainText>
            </Box>
          </PressableOpacity>
        </Box>
      </Box>
    </MySafeAreaView>
  );
};

export default WelcomeScreen;
